// src/services/authService.js
import apiClient from './api';

const API_BASE_URL_FOR_OAUTH_LINKS = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080';

const OAUTH2_BASE_URL = `${API_BASE_URL_FOR_OAUTH_LINKS}/oauth2/authorization`;

// NOWA FUNKCJA
const getOAuth2LoginUrlWithInvitation = (provider, invitationToken) => {
    const params = new URLSearchParams();
    if (invitationToken) {
        params.append('invitation_token', invitationToken);
    }
    const queryString = params.toString();
    return `${OAUTH2_BASE_URL}/${provider}${queryString ? `?${queryString}` : ''}`;
};

const register = (username, email, password, firstName, lastName) => {
    return apiClient.post('/auth/signup', { username, email, password, firstName, lastName });
};

const login = (username, password, ghostUserId) => {
    return apiClient.post('/auth/signin', { username, password, ghostUserId })
        .then((response) => response.data);
};

const loginWithCode = (code) => {
    return apiClient.post('/auth/signin-with-code', { code })
        .then((response) => response.data);
};

const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
};

const getCurrentUser = () => {
    const userStr = localStorage.getItem('user');
    if (userStr) return JSON.parse(userStr);
    return null;
};

const getToken = () => localStorage.getItem('token');

const fetchUserInfo = () => {
    return apiClient.get('/auth/userinfo').then(response => response.data);
};

const authService = {
    register,
    login,
    loginWithCode,
    logout,
    getCurrentUser,
    getToken,
    fetchUserInfo,
    getOAuth2LoginUrlWithInvitation, // EKSPORTUJEMY NOWĄ FUNKCJĘ
    OAUTH2_LOGIN_URL_GOOGLE: `${OAUTH2_BASE_URL}/google`,
    OAUTH2_LOGIN_URL_FACEBOOK: `${OAUTH2_BASE_URL}/facebook`,
};

export default authService;